import type { ResponseData } from '@components/DynamicActions/hooks/useActionParams'
import type { Action } from '@components/DynamicActions/types'

export const readResponseActions = (source: object | null | undefined): Array<Action> =>
  (source as { actions?: Array<Action> } | null | undefined)?.actions ?? []

export const checkFieldCondition = (values: Record<string, unknown>, condition: Record<string, unknown>) =>
  Object.entries(condition || {}).every(([key, value]) => values[key] === value)

export const checkForResetPasswordForCurrentUser = async (
  actionName: string | undefined,
  res: ResponseData,
  currentUserEmail: string | undefined,
  routerPush: (path: string) => void,
) => {
  if (actionName !== 'Reset Password') {
    return
  }

  const resetUserEmail = res?.data?.data?.actionable_object?.email

  const isCurrentUserRequestPasswordReset = currentUserEmail === resetUserEmail
  if (isCurrentUserRequestPasswordReset) {
    routerPush('/login')
  }
}
